module.exports = __webpack_public_path__ + "static/media/15_Killiam_M@3x.8321a57d.jpg";